/** Shared catalog helpers (category labels) used by the grid and detail sheet. */

/** Human labels for the category slugs the backend stores (pods/disposables/…). */
export const CATEGORY_LABELS: Record<string, string> = {
  pods: "Pods",
  disposables: "Disposables",
  kits: "Kits",
  liquids: "E-liquids",
  tobacco: "Tobacco",
  accessories: "Accessories",
};

export function categoryLabel(slug: string): string {
  return CATEGORY_LABELS[slug] ?? slug.charAt(0).toUpperCase() + slug.slice(1);
}
